const socketApi = "https://onespace.fabmediatech.com";
//const socketApi = "http://localhost:9000";

export default socketApi;



